import type { CheckRoutingNumberQuery } from '#api/shared/@types/generated/backend/graphql-schema-types'

type CheckRoutingNumberQueryFallback = Omit<
  CheckRoutingNumberQuery['checkRoutingNumber'],
  '__typename'
>

const CHECK_ROUTING_NUMBER_FALLBACK: CheckRoutingNumberQueryFallback = {
  bankName: '',
  isKnown: false,
}

export const useBankName = () => {
  const { load, refetch } = useCheckRoutingNumberLazyQuery()
  const { log } = useDatadog()

  const getBankName = async (routingNumber: string) => {
    try {
      const loadResult = await load(null, {
        routingNumber: String(routingNumber),
      })

      if (typeof loadResult !== 'boolean') {
        const { __typename, ...data } = loadResult.checkRoutingNumber
        return data
      }

      const refetchResult = await refetch({
        routingNumber: String(routingNumber),
      })

      if (!refetchResult?.data) return CHECK_ROUTING_NUMBER_FALLBACK

      const { __typename, ...data } = refetchResult.data.checkRoutingNumber
      return data
    } catch (error) {
      log('error', {
        component: 'bankName.ts',
        message: 'Failed to fetch bank name for routing number',
        messageContext: { error },
      })

      return CHECK_ROUTING_NUMBER_FALLBACK
    }
  }

  return { getBankName }
}
